<template>
  <page-content></page-content>
</template>

<script>
  /*edit chart component from audit mixin*/

  // components
  import PageContent from './components/PageContent.vue';

  export default {
    name: "AuditEdit",
    components: {
      PageContent
    }
  };
</script>
